export class POBaseNotify {
  notifyType: string;
  dateTimeUTC: string;
  // Initiator
  operatorId: number;
  operatorName: string;
}
